var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ding-bu'),_c('router-view'),_c('di-bu')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }